export default "__VITE_ASSET__DMPXK2Sz__"